import * as React from "react";
import {
  IconAlertTriangleFilled,
  IconCircleCheckFilled,
  IconInfoCircle,
} from "@tabler/icons-react";
import clsx from "clsx";

interface Props {
  title?: string;
  text: string;
  type: "danger" | "success"
  icon?: React.ReactNode;
}

const getTypeStyle = (type: Props["type"]) => {
  switch (type) {
    case "danger":
      return "bg-red-50 border border-red-600 text-slate-950";
    case "success":
      return "bg-green-50 border border-green-600 text-slate-950";
    default:
      return "bg-gray-50 border border-gray-200 text-gray-600";
  }
};

const getTypeIcon = (type: Props["type"], icon?: React.ReactNode) => {
  if (icon) return icon;
  switch (type) {
    case "danger":
      return <IconAlertTriangleFilled className="text-red-600" size={20} />;
    case "success":
      return <IconCircleCheckFilled className="text-green-600" size={20} />;
    default:
      return <></>;
  }
};

const InlineToast: React.FC<Props> = ({
  title, text, type, icon,
}) => (
  <div className={clsx(
    getTypeStyle(type),
    "flex gap-2 p-3 rounded-xl",
  )}
  >
    {getTypeIcon(type, icon)}
    <div className="text-sm text-slate-950">
      {title && <div className="font-semibold mb-2">{title}</div>}
      {text}
    </div>
  </div>
);

export default InlineToast;
